import { funcState } from '../../utils/funcState';
import { Filters } from '../utils/filtersEnum';

const NameProvider = ({ updateFilter }) => {
  const [name, setName] = funcState();

  const update = ({ queryParams }) => {
    setName(queryParams?.name);

    updateFilter({
      key: Filters.Name,
      value: { name: name.value },
    });
  };

  const toQueryParams = () => ({ name: name.value });

  return { exposed: {}, update, toQueryParams };
};

export default NameProvider;
